const Footer = () => {
    return (
      <footer className="footer">
        <div className="content has-text-centered">
          <p>
            このサイトは
            <a 
            href="https://webservice.rakuten.co.jp/documentation/gora-golf-course-search"
            target="_blank"
            >
              楽天GORAゴルフ場検索API
            </a>
            を使用しています。
          </p>
          <p>moriya</p>
        </div>
      </footer>
    );
  };
  export default Footer;
  